export const initFacebookSdk = function () {
    let body = document.body;
    let facebookScript = document.createElement("script");
    facebookScript.async = true;
    facebookScript.defer = true;
    facebookScript.crossOrigin = "anonymous";
    facebookScript.src = "https://connect.facebook.net/en_US/sdk.js";
    body.appendChild(facebookScript);
};

export const fbAsyncInit = function() {
    window.FB.init({
        appId            : window.bubblyWebsiteConfig.FACEBOOK_APP_ID,
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v' + window.bubblyWebsiteConfig.FACEBOOK_SDK_VERSION
    });
};